import React, { useState } from "react";
import styles from "./LoginForm.module.css";
import { Link } from "react-router-dom";
import { requestPasswordReset } from "../../api/Api";

import emailjs from 'emailjs-com';

export const PasswordResetRequest = (props) => {

    // props:
    // 
    // setIsRestingPassword - state setter for parent

    // ----------------------------------------------------- STATE AND HOOKS
    let token = localStorage.getItem("token");

    const [email, setEmail] = useState(null);
    const [emailSent, setEmailSent] = useState(false);

    const [isSubmitting, setIsSubmitting] = useState(false);

    // ----------------------------------------------------- PRE-RENDER

    async function handleSubmit() {
        // sends request to back for reset token
        if (email === "" || email === null) return;

        setIsSubmitting(true);

        await requestPasswordReset(email)
            .then((link) => {
                sendResetEmail(link);
            })
            .catch((error) => {
                console.log(error, "failed to request reset token");
                setIsSubmitting(false);
            })
    }

    function sendResetEmail(link) {
        // sets email to user

        let emailParams = {
            "email": email,
            "link": link
        }

        emailjs.send(
            "earmarked",
            "reset_password",
            emailParams,
            'zzKVq_gPiaT31H8J4'
        )
            .then(() => {
                setEmailSent(true);
                setIsSubmitting(false);
            })
            .catch((error) => {
                console.log("failed to send email", error);
                setEmailSent("failure");
                setIsSubmitting(false);
            })
    }

    const handleKeyDown = (event) => {
        // checks to see if key is enter and submits if it is
        if (event.keyCode === 13) {
            handleSubmit();
        }
    }

    // ----------------------------------------------------- RENDER

    if (emailSent === true) {
        return (
            <div className={styles.form}>
                <h1 className={styles.labelHeader}>Reset email has been sent</h1>
            </div>
        )
    } else if (emailSent === false) {
        return (
            <section className={styles.container}>
                <h1 className={styles.sectionHeader}>Reset Password</h1>
                <div className={styles.form}>
                    <div className={styles.labelHeader}>
                        <h1>Email</h1>
                        <input type="text"
                            className={styles.inputBox}
                            onChange={event => setEmail(event.target.value)} 
                            onKeyDown={handleKeyDown}/>
                    </div>
                    <div className={styles.buttons}>
                        <button onClick={() => props.setIsResettingPassword(false)} className={styles.cancelButton}>Cancel</button>
                        <button onClick={handleSubmit} className={styles.submitButton}>{isSubmitting ? "Submitting..." : "Submit"}</button>
                    </div>
                </div>
            </section>
        )
    } else {
        return (
            <div className={styles.form}>
                <h1>Something whent wrong</h1>
            </div>
        )
    }


}